import type {
  NumberFormatDTO,
  StoreDTO
} from '@/services/generated/ECAPIStoresDTOs';
import { simplifyTechnologies } from '@/domain/Product.ts';
import type { Market } from '../Market';
import type { PriceFormat } from '../Pricing';

export function fromEcapiDto(
  marketConfig: StoreDTO,
  amountFormat: NumberFormatDTO
): Market {
  return {
    financialSettings: {
      defaultCurrency: marketConfig.financialSettings.defaultCurrency,
      taxSystem: marketConfig.financialSettings.taxSystem,
      tariff: marketConfig.financialSettings.tariff,
      pricingModel: marketConfig.financialSettings?.pricingModel ?? 'CAPSULE'
    },
    priceFormat: {
      decimalSeparator: amountFormat?.decimalSeparator ?? ',',
      thousandsGroupingSeparator:
        amountFormat?.thousandsGroupingSeparator ?? '.',
      minimumFractionDigits: amountFormat?.minimumFractionDigits ?? 0,
      maximumFractionDigits: amountFormat?.maximumFractionDigits ?? 2,
      minusSign: amountFormat?.minusSign ?? '-',
      pattern: amountFormat?.pattern ?? '{currency}{sign}{amount}'
    } satisfies PriceFormat,
    technologies: simplifyTechnologies(
      marketConfig.enabledTechnologies,
      marketConfig.preferredTechnology
    ),
    discoveryOfferBundleProducts: marketConfig.discoveryOfferBundleProducts
  };
}
